import { RichText } from '@sitecore-jss/sitecore-jss-react';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { RouterStateButton } from '../forms/elements';
import Heading from '../heading/Heading';

var OfflineOrderDetails = function OfflineOrderDetails(props) {
  var _selectedOrder$fulfil, _selectedOrder$fulfil2, _selectedOrder$fulfil3, _selectedOrder$fulfil4, _selectedOrder$fulfil5, _selectedOrder$fulfil6, _selectedOrder$fulfil7, _selectedOrder$fulfil8, _selectedOrder$billin, _selectedOrder$billin2, _selectedOrder$billin3, _selectedOrder$billin4;

  var selectedOrder = props.selectedOrder,
      isGuest = props.isGuest,
      _props$returnAction = props.returnAction,
      returnAction = _props$returnAction === void 0 ? function () {
    return "";
  } : _props$returnAction; // const {Status, Price} = order

  var title = "Order # ".concat(selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.orderNumber);
  var submittedDate = moment(selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.submittedDate).format("MM-DD-YYYY");
  var orderTitle = "Ordered on ".concat(submittedDate);
  var shippingAddress = selectedOrder === null || selectedOrder === void 0 ? void 0 : (_selectedOrder$fulfil = selectedOrder.fulfillmentInfo) === null || _selectedOrder$fulfil === void 0 ? void 0 : (_selectedOrder$fulfil2 = _selectedOrder$fulfil.fulfillmentContact) === null || _selectedOrder$fulfil2 === void 0 ? void 0 : _selectedOrder$fulfil2.address;
  var customerName = (selectedOrder === null || selectedOrder === void 0 ? void 0 : (_selectedOrder$fulfil3 = selectedOrder.fulfillmentInfo) === null || _selectedOrder$fulfil3 === void 0 ? void 0 : (_selectedOrder$fulfil4 = _selectedOrder$fulfil3.fulfillmentContact) === null || _selectedOrder$fulfil4 === void 0 ? void 0 : _selectedOrder$fulfil4.firstName) + " " + (selectedOrder === null || selectedOrder === void 0 ? void 0 : (_selectedOrder$fulfil5 = selectedOrder.fulfillmentInfo) === null || _selectedOrder$fulfil5 === void 0 ? void 0 : (_selectedOrder$fulfil6 = _selectedOrder$fulfil5.fulfillmentContact) === null || _selectedOrder$fulfil6 === void 0 ? void 0 : _selectedOrder$fulfil6.lastNameOrSurname);
  var customerEmail = selectedOrder === null || selectedOrder === void 0 ? void 0 : (_selectedOrder$fulfil7 = selectedOrder.fulfillmentInfo) === null || _selectedOrder$fulfil7 === void 0 ? void 0 : (_selectedOrder$fulfil8 = _selectedOrder$fulfil7.fulfillmentContact) === null || _selectedOrder$fulfil8 === void 0 ? void 0 : _selectedOrder$fulfil8.email;
  var customePhoneNumber = selectedOrder === null || selectedOrder === void 0 ? void 0 : (_selectedOrder$billin = selectedOrder.billingInfo) === null || _selectedOrder$billin === void 0 ? void 0 : (_selectedOrder$billin2 = _selectedOrder$billin.billingContact) === null || _selectedOrder$billin2 === void 0 ? void 0 : (_selectedOrder$billin3 = _selectedOrder$billin2.phoneNumbers) === null || _selectedOrder$billin3 === void 0 ? void 0 : _selectedOrder$billin3.home;
  var paymentType = selectedOrder === null || selectedOrder === void 0 ? void 0 : (_selectedOrder$billin4 = selectedOrder.billingInfo) === null || _selectedOrder$billin4 === void 0 ? void 0 : _selectedOrder$billin4.paymentType;
  var items = selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.items;
  return /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: {
      value: title
    },
    className: "cb-account__title"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-checkout__header"
  }, /*#__PURE__*/React.createElement(RouterStateButton, {
    href: "/shop/orders",
    className: "cb-button-unstyled"
  }, "Go Back")), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__header"
  }, /*#__PURE__*/React.createElement("h3", null, "Customer Details")), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order__container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "3"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Name:")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, customerName))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Email:")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, customerEmail))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Phone Number:")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, customePhoneNumber))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Shipping to:"), /*#__PURE__*/React.createElement("p", null, shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.address1, " ", shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.address2, /*#__PURE__*/React.createElement("br", null), shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.cityOrTown, ", ", shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.stateOrProvince, " ", shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.postalOrZipCode))))), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__header"
  }, /*#__PURE__*/React.createElement("h3", null, orderTitle)), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order__container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Container, null, items === null || items === void 0 ? void 0 : items.map(function (item, index) {
    var _item$product;

    var imgUrl = (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.image;
    return /*#__PURE__*/React.createElement("div", {
      key: "cart-item-".concat(index)
    }, /*#__PURE__*/React.createElement("div", {
      className: "cb-cart__item"
    }, /*#__PURE__*/React.createElement("img", {
      src: imgUrl
    }), /*#__PURE__*/React.createElement("div", {
      className: "cb-card__item-contents"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cb-card__item-contents--cart"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RichText, {
      tag: "p",
      className: "cb-cart__item__copy",
      field: {
        value: item.product.name
      }
    }), /*#__PURE__*/React.createElement(RichText, {
      tag: "p",
      className: "cb-cart__item__copy",
      field: {
        value: item.product.productCode
      }
    }))))), /*#__PURE__*/React.createElement("div", {
      className: "cb-cart__modification"
    }, /*#__PURE__*/React.createElement("p", null, "Qty: ", item.quantity)));
  }))), /*#__PURE__*/React.createElement(Col, {
    lg: "3"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Status:")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.status))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Payment Type:")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, paymentType))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Subtotal:")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, "$", selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.subtotal))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Shipping:")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, "$", selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.shippingTotal))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Total:")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, "$", selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.total)))))))));
};

export default OfflineOrderDetails;